import { makeStyles } from '@material-ui/core';
import { Font, PDFViewer } from '@react-pdf/renderer';
import { FunctionComponent, useEffect } from 'react';
import { CONNECT_SCREENS } from '../../../constants';
import { Analytics } from '../../../helpers/analytics/Analytics';
import { AnalyticsEventName } from '../../../helpers/analytics/AnalyticsEvent';
import { useAuthStore } from '../../../store/AuthStore';
import { ConnectInitializeUser } from '../../../store/StoreTypes';
import { OnePageDocument } from './OnePageDocument';

/** avoid hyphenation */
Font.registerHyphenationCallback((word) => [word]);

export const ReferralOnePagerScreen: FunctionComponent = () => {
  /** redux state cannot be directly accessed inside the PDFViewer component, so we need to pass it in as a prop */
  const hcpUser = useAuthStore((state) => state.user as ConnectInitializeUser);
  const classes = useStyles();

  useEffect(function trackAnalytics() {
    Analytics.track({
      event: AnalyticsEventName.h_screen_viewed,
      screen: CONNECT_SCREENS.REFERRAL_ONE_PAGER,
    });
  }, []);

  return (
    <PDFViewer className={classes.viewer}>
      <OnePageDocument hcpUser={hcpUser} />
    </PDFViewer>
  );
};

const useStyles = makeStyles({
  viewer: {
    width: '100%',
    minHeight: '87.5vh',
  },
});
